import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';
import { ChangePasswordAdminService } from './core/change-password-admin.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
    selector: 'change-password-admin',
    templateUrl: 'change-password-admin.component.html',
    styleUrls: ['change-password-admin.component.scss']
})
export class ChangePasswordAdminComponent {
    changingPassword: boolean;
    password: string;
    verificationPassword: string;

    constructor(private _translateService: TranslateService,
        private _toastService: BzgToastService,
        private _changeAdminPasswordService: ChangePasswordAdminService,
        private _i18nService: I18nService,
        private _showToastService: ShowToastService
    ) { }

    ngOnInit() {

    }

    public async changeAdminPassword() {
        this.changingPassword = true;
        await this._changeAdminPasswordService.changeAdminPassword(this.password);
        this._showToastService.showToast(this._i18nService.instant('CHANGE_PASSWORD_ADMIN.SUCCESS_MSG'), 'success');
        this.changingPassword = false;

    }

    public isPasswordInvalid(): boolean {
        return !this.password || !this.verificationPassword || this.verificationPassword !== this.password;
    }

    public cancel() {
        this.password = '';
        this.verificationPassword = '';
    }
}
